<template>
  <div class="container-fluid autenticacao">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">Listagem de Contribuintes</h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          
          <a @click="login()" style="text-decoration: underline; position: relative; text-align: left;">Clique aqui para retornar ao Login</a>
          
          <hr/>
          
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="tipoConsulta" name="tipoConsulta" v-model="selectedTipoConsulta" :options="tiposConsulta"
                  optionLabel="name" placeholder="Tipo Consulta:" />
              </span>
            </div>
            <div class="col-md-2 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="tipoSelecao" name="tipoSelecao" v-model="selectedTipoSelecao" :options="tiposSelecao"
                  optionLabel="name" placeholder="Tipo Seleção:" />
              </span>
            </div>
            <div class="col-md-4 mb-2">
              <span class="p-fluid">
                <InputText v-model="filtro" placeholder="Filtro" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="mb-2">
              <Button @click="pesquisar()" label="Pesquisar" type="button" class="p-button-primary mr-2"
                icon="pi pi-search" :disabled="loading" />
            </div>
          </div>
          <div class="row">
            <DataTable :value="usuarioList" :paginator="true" :rows="10" :scrollable="false" :autoLayout="true"
              class="p-datatable-responsive">
              <template #header>
                <div style="line-height:1.87em" class="p-clearfix">Lista de Contribuintes.</div>
              </template>

              <Column header="Documento" headerStyle="width: 12em">
                <template #body="slotProps">
                  <span class="p-column-title">Documento</span>
                  {{slotProps.data.documento}}
                </template>
              </Column>
              <Column header="Nome">
                <template #body="slotProps">
                  <span class="p-column-title">Nome</span>
                  {{slotProps.data.nome}}
                </template>
              </Column>
              <Column header="Inscrição Municipal" headerStyle="width: 12em">
                <template #body="slotProps">
                  <span class="p-column-title">Inscrição Municipal</span>
                  {{slotProps.data.inscricaoMunicipal}}
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SolicitacaoCadastroService from "../services/tributario/solicitacao.cadastro.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";

export default {
  name: "selecaoEmpresa",
  data() {
    return {
      loading: false,
      filters: {},
      filtro: null,
      tiposConsulta: [],
      tiposSelecao: [],
      selectedTipoConsulta: null,
      selectedTipoSelecao: null,
      usuarioList: [],
      idCliente: null
    };
  },
  mounted() {

    setTimeout(async () => {
      this.processando(true);
      let host = window.location.hostname;
      this.dnsCliente = await DnsClienteService.get(host);
      this.filtro = "";
      this.selectedTipoConsulta = { name: "CPF/CNPJ", key: "D" };
      this.selectedTipoSelecao = { name: "Emissores de NFS-e", key: "C" };
      this.tiposConsulta = [
        { name: "CPF/CNPJ", key: "D" },
        { name: "Nome Contribuinte", key: "N" },
        { name: "Inscrição Municipal", key: "I" }
      ];
      this.tiposSelecao = [
        { name: "Emissores de NFS-e", key: "C" },
        { name: "TODOS", key: "T" }
      ];
      if (
        this.dnsCliente &&
        this.dnsCliente.data &&
        this.dnsCliente.data.idCliente
      ) {
        this.idCliente = this.dnsCliente.data.idCliente;
        this.pesquisar();
      }
      this.processando(false);
    }, 250);
  },
  created() {

  },
  methods: {
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    pesquisar() {
      this.processando(true);
      this.search = true;


      SolicitacaoCadastroService.findAllContrFiltro(
        this.idCliente,
        this.filtro,
        this.selectedTipoConsulta.key,
        this.selectedTipoSelecao.key
      ).then(ua => {
        this.usuarioList = ua.data;
      }).then(() => {
        this.processando(false);
        this.search = false;
      });



    },login() {
      this.$router.push("/login");
    },
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>
